import type { RouterOutputs } from "@repo/api";
import type { NotificationTypes } from "@repo/database";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { NotificationContext } from "~/hooks/use-notification";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";

export type Notification =
  RouterOutputs["notification"]["getPaginated"]["notifications"][number];

export interface RealtimeNotification {
  id: string;
  createdAt: string;
  type: NotificationTypes;
  seenAt?: string;
  archivedAt?: string;
  booking?: {
    id: string;
    startTime: Date;
    groupSize: number;
  };
}

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  // const { data: notifications, isFetching: isNotificationsLoading } =
  //   api.notification.getPaginated.useQuery(
  //     { limit: 15, offset: 0 },
  //     {
  //       initialData: { notifications: [], totalUnseen: 0 },
  //     },
  //   );

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  // useEffect(() => {
  //   if (isNotificationsLoading) {
  //     setLoadingStage("labels");
  //   } else {
  //     setLoadingStage(undefined);
  //   }
  // }, [isNotificationsLoading, setLoadingStage]);

  const context = {
    notifications: [],
    totalUnseen: 0,
  };

  return (
    <NotificationContext.Provider value={context}>
      {children}
    </NotificationContext.Provider>
  );
}
